import api from "@/api/apiUser";

export default {
  namespaced: true,
  state() {
    return {
      clickApi: false,
      agreeApi: false,
      deleteApi: false,
      agreeChk: false,
      clickPosition: false,
      clickResult: false,
      clickBonus: false,
      userId: null,

      nowPage: 1, // api 호출 시 page 에 해당
      language: localStorage.getItem("localeLang"), // api 호출 시 language 에 해당

      dailyPages: 1, // daily 전체 페이지
      weeklyPages: 1, // weekly 전체 페이지
      monthlyPages: 1, // monthly 전체 페이지

      dailyList: [], // daily 히스토리
      weeklyList: [], // weekly 히스토리
      monthlyList: [], // monthly 히스토리
    };
  },
  mutations: {
    changeApi(state, payload) {
      state.clickApi = payload.state;
    },
    changeAgree(state, payload) {
      state.agreeApi = payload.state;
    },
    changeDelete(state, payload) {
      state.deleteApi = payload.state;
    },
    changeChkState(state, value) {
      state.agreeChk = value;
    },
    changePosition(state, payload) {
      state.clickPosition = payload.state;
    },
    changeResult(state, payload) {
      state.clickResult = payload.state;
    },
    changeBonus(state, payload) {
      state.clickBonus = payload.state;
    },
    setAuth(state, payload) {
      state.userId = payload.userId;
    },
    changePage(state, value) {
      state.nowPage = value;
    },
    changeLang(state, value) {
      state.language = value;
    },
  },
  actions: {
    async getDaily(context) {
      try {
        let result = await api.getDayHistories(
          context.state.nowPage,
          context.state.language
        );
        if (result.isSuccess) {
          context.state.dailyPages = result.data.totalPage;
          // context.state.dailyPages = 4;
          let data = result.data.histories;

          // 리트리 페이지와 동일하게 반올림 처리
          for (let key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
              let value = data[key].amount;
              if (typeof value === "number" && value.toString().split(".")[1]) {
                let decimalCount = value.toString().split(".")[1].length;
                if (decimalCount >= 2) {
                  data[key].amount = parseFloat(value.toFixed(2));
                }
              }
            }
          }

          for (let pay of data) {
            let year = pay.payDate.slice(0, 4);
            let month = pay.payDate.slice(4, 6);
            let day = pay.payDate.slice(6, 8);

            pay.Date = `${year}-${month}-${day}`;
          }

          context.state.dailyList = data;
        }
      } catch (error) {
        // console.log('nowPage', context.state.nowPage)
        // context.state.dailyPages = 4;
        // if (context.state.nowPage == 1) {

        //   context.state.dailyList = [
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //     { Date: '2025-04-15', amount: '3000', title: 'MVP Bonus' },
        //   ]
        // }

        // else {
        //    context.state.dailyList = [
        //   { Date: '2025-04-16', amount: '5000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        //   { Date: '2025-04-15', amount: '1000', title: 'MVP Bonus' },
        // ]
        // }

        console.error("Error get daily bonus histories:", error);
      }
    },
    async getWeekly(context) {
      try {
        let result = await api.getWeekHistories(
          context.state.nowPage,
          context.state.language
        );
        if (result.isSuccess) {
          context.state.weeklyPages = result.data.totalPage;
          let data = result.data.histories;

          // 리트리 페이지와 동일하게 반올림 처리
          for (let key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
              let value = data[key].amount;
              if (typeof value === "number" && value.toString().split(".")[1]) {
                let decimalCount = value.toString().split(".")[1].length;
                if (decimalCount >= 2) {
                  data[key].amount = parseFloat(value.toFixed(2));
                }
              }
            }
          }

          for (let pay of data) {
            let year = pay.payDate.slice(0, 4);
            let month = pay.payDate.slice(4, 6);
            let day = pay.payDate.slice(6, 8);

            pay.Date = `${year}-${month}-${day}`;
          }
          context.state.weeklyList = data;
        }
      } catch (error) {
        console.error("Error get weekly bonus histories:", error);
      }
    },
    async getMonthly(context) {
      try {
        let result = await api.getMonthHistories(
          context.state.nowPage,
          context.state.language
        );
        if (result.isSuccess) {
          context.state.monthlyPages = result.data.totalPage;
          let data = result.data.histories;

          // 리트리 페이지와 동일하게 반올림 처리
          for (let key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
              let value = data[key].amount;
              if (typeof value === "number" && value.toString().split(".")[1]) {
                let decimalCount = value.toString().split(".")[1].length;
                if (decimalCount >= 2) {
                  data[key].amount = parseFloat(value.toFixed(2));
                }
              }
            }
          }

          for (let pay of data) {
            let year = pay.payDate.slice(0, 4);
            let month = pay.payDate.slice(4, 6);
            let day = pay.payDate.slice(6, 8);

            pay.Date = `${year}-${month}-${day}`;
          }
          context.state.monthlyList = data;
        }
      } catch (error) {
        console.error("Error get monthly bonus histories:", error);
      }
    },
  },
};
